export const BUNDLE_TYPE_PROMOTION = 'promo';
export const BUNDLE_TYPE_FANCY = 'fancy';

export const PRODUCT_KIND_DEVICE = 'Product';
export const PRODUCT_KIND_ACCESSORY = 'Accessory';
export const PRODUCT_KIND_TARIFF = 'Tariff';
export const PRODUCT_KIND_BILLING = '100';
export const PRODUCT_KIND_FANCYNUMBER = 'FancyNumber';
export const TARIFF_DEFAULT_IMG =
  '//static.beeline.ru/upload/images/e-shop/product-detail/3fFYtm66dl.png';
export const TARIFF_ESIM_IMG =
  '//static.beeline.ru/upload/dpcupload/contents/291/icons/eSIM_benefit_purple-2-01.svg';
export const SCROLL_BUNDLE_GUTTER = -20;
